import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { DomainCacheService } from './domain-cache.service';

const baseRef = 'grupo';
const route = {
  combo: (tipo: string) => `${baseRef}/combo/${tipo}`,
};

@Injectable({
  providedIn: 'root'
})
export class GrupoService {
  constructor(
    private apiService: ApiService,
    private domainCache: DomainCacheService
  ) { }

  combo(tipo: string): Observable<any> {
    const key = `grupo/combo/${tipo}`;
    return this.domainCache.getOrLoad(key, () =>
      this.apiService.get<any>(route.combo(tipo), undefined, undefined, true)
    );
  }
}
